"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var siteGroupsBaseTheme = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var MAX_XS = _a.MAX_XS, MAX_S = _a.MAX_S, MIN_L = _a.MIN_L, MAX_L = _a.MAX_L, MEDIA_PRINT = _a.MEDIA_PRINT;
    return ({
        siteGroups: {
            flex: 1
        },
        siteGroupsFeaturedContainer: (_b = {
                borderRadius: "0.25rem",
                flex: 1
            },
            _b[MAX_L] = {
                marginBottom: "20px",
                paddingTop: "1.5rem"
            },
            _b),
        siteGroupsFeaturedTitle: (_c = {
                paddingBottom: "1.5rem",
                fontSize: "1.875rem"
            },
            _c[MAX_S] = {
                fontSize: "1rem",
                fontWeight: "bolder",
                paddingBottom: "1.125rem"
            },
            _c),
        siteGroupsRelatedResourcesTitle: (_d = {
                fontSize: "1.875rem"
            },
            _d[MIN_L] = {
                paddingTop: "2rem",
                paddingBottom: "2rem"
            },
            _d[MAX_L] = {
                paddingBottom: "2rem",
            },
            _d[MAX_S] = {
                fontSize: "16px",
                textAlign: "center"
            },
            _d),
        siteGroupsRelatedResourcesIcon: {
            height: "60px",
            margin: "auto"
        },
        siteGroupsRelatedResourcesLink: (_e = {
                display: "grid",
                gridGap: "0.25rem",
                justifyContent: "center",
                alignItems: "center",
                textDecoration: "none",
                margin: "0 auto",
                gridAutoRows: "max-content",
                marginTop: "0.25rem",
                // width needs to be 131px to allow Register for Viewpoint Academy to fit one two lines
                textAlign: "center",
                verticalAlign: "top",
                fontSize: "0.875rem"
            },
            _e[MAX_L] = {},
            _e[MAX_S] = {
                fontWeight: "normal",
            },
            _e),
        siteGroupsVideosIcon: {
            "&.material-icons": (_f = {
                    display: "none"
                },
                _f[MEDIA_PRINT] = {
                    display: "flex",
                    alignItems: "center",
                    width: "50%",
                    justifyContent: "center",
                    margin: "1rem auto",
                    border: "1px solid gray",
                    fontSize: "5rem",
                    padding: "6rem 5rem",
                },
                _f),
        },
        siteGroupsRelatedResourcesList: (_g = {
                display: "grid",
                gridTemplateColumns: "repeat(6, 1fr)"
            },
            _g[MAX_L] = {
                gridTemplateColumns: "1fr 1fr 1fr",
                "& > div": {
                    marginBottom: "20px"
                }
            },
            _g[MAX_S] = {
                gridTemplateColumns: "1fr 1fr",
                gridRowGap: "1rem"
            },
            _g[MAX_XS] = {
                gridTemplateColumns: "100%",
            },
            _g),
        siteGroupsFeatured: (_h = {
                display: "flex",
                flexDirection: "row",
                flex: 1
            },
            _h[MAX_L] = {
                flexDirection: "column",
            },
            _h),
        siteGroupsFeaturedItem: {},
        siteGroupsVideos: (_j = {
                flex: 1
            },
            _j[MIN_L] = {
                paddingTop: "2rem"
            },
            _j[MAX_L] = {
                padding: "2.5rem",
            },
            _j[MAX_S] = {
                padding: 0,
            },
            _j),
        siteGroupsVideosContainer: (_k = {
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                paddingTop: "2rem",
                gridGap: "1rem"
            },
            _k[MAX_L] = {
                gridTemplateColumns: "100%",
            },
            _k),
        siteGroupsVideosItem: {},
        siteGroupsVideosTitle: (_l = {
                fontSize: "1.875rem"
            },
            _l[MAX_S] = {
                fontSize: "1rem",
                fontWeight: "bolder",
                textAlign: "center",
                paddingBottom: "10px !important",
            },
            _l),
        siteGroupsBanner: {
            display: "flex",
            justifyContent: "center",
            "& img": {
                width: "100%",
                height: "auto"
            }
        },
        siteGroupsVideosPlayer: {
            height: "100%"
        },
    });
};
exports.default = siteGroupsBaseTheme;
//# sourceMappingURL=siteGroups.js.map